/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { next } from '@ember/runloop';
import { isEmpty } from '@ember/utils';

import ActionModel from 'cio/models/action';
import TemplateModel from 'cio/models/template';
import AuthService from 'cio/services/auth';
import EventBusService, { EMAIL_COMPOSER_ROLLBACK } from 'cio/services/event-bus';
import { ComposerActionTypeName } from 'cio/utils/composer';
import ComposerEditableEntity from 'cio/utils/composer/composer-editable-entity';

export enum ComposerTab {
  Editor = 'editor',
  Preview = 'preview',
}

export type ActionComposerV2Signature = {
  Args: {
    editableEntity: ComposerEditableEntity;
    type: ComposerActionTypeName;
    templateVariables: Record<string, any>;
    composerTab: ComposerTab;
    eventName?: string;
    startFromScratch: () => unknown;
    onSave: () => Promise<unknown>;
    didSelectTemplate: () => Promise<unknown>;
    onDirtyChange?: (dirty: boolean) => unknown;
    onTabChange?: (tab: ComposerTab) => unknown;
    hasReadOnlyPermission: boolean;
  };
  Element: HTMLDivElement;
};

export default class ActionComposerV2 extends Component<ActionComposerV2Signature> {
  @service auth!: AuthService;
  @service eventBus!: EventBusService;

  @tracked translationPendingDeletion?: ActionModel | TemplateModel = undefined;

  get isNewEmailTemplate() {
    return this.args.editableEntity.isEmail && isEmpty(this.args.editableEntity.template?.editor);
  }

  @action
  onDirtyChangeAction(isDirty: boolean) {
    return this.args.onDirtyChange?.(isDirty);
  }

  @action
  onRollback() {
    // Let bindings sync and then alert other components that need to do some manual work for the rollback.
    next(this, () => {
      this.eventBus.publish(EMAIL_COMPOSER_ROLLBACK);
    });
  }

  @action
  onSave() {
    return this.args.onSave();
  }
}
